import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton, SkeletonGroup } from '@/components/ui/skeleton'

const FUNNEL_BAR_WIDTHS = ['w-full', 'w-3/4', 'w-1/2', 'w-1/3', 'w-1/5']

function CardHeaderSkeleton() {
  return (
    <CardHeader className="flex flex-col gap-2">
      <Skeleton className="h-5 w-48" />
      <Skeleton className="h-4 w-72 max-w-full" />
    </CardHeader>
  )
}

function TableCardSkeleton() {
  return (
    <Card>
      <CardHeaderSkeleton />
      <CardContent className="flex flex-col gap-3">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="h-8 w-full" />
        ))}
      </CardContent>
    </Card>
  )
}

/** Stands in for the analytics cards while the summary loads. */
export function SalesAnalyticsSkeleton() {
  return (
    <SkeletonGroup className="flex flex-col gap-6">
      <Card>
        <CardHeaderSkeleton />
        <CardContent className="flex flex-col gap-2">
          {FUNNEL_BAR_WIDTHS.map((width) => (
            <div key={width} className="grid grid-cols-[11rem_1fr_auto] items-center gap-3">
              <Skeleton className="h-4 w-24" />
              <Skeleton className={`h-6 ${width}`} />
              <Skeleton className="h-4 w-16" />
            </div>
          ))}
        </CardContent>
      </Card>
      <div className="grid gap-6 lg:grid-cols-2">
        <TableCardSkeleton />
        <TableCardSkeleton />
      </div>
      <TableCardSkeleton />
      <TableCardSkeleton />
    </SkeletonGroup>
  )
}
